"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[101],{

/***/ 540101:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);
/* harmony import */ var _redux_actions__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(731024);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(225617);
/* harmony import */ var next_dynamic_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(505152);
/* harmony import */ var next_dynamic_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_dynamic_js__WEBPACK_IMPORTED_MODULE_2__);




var AuthModal = next_dynamic_js__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(6956), __webpack_require__.e(4814), __webpack_require__.e(3973), __webpack_require__.e(7287)]).then(__webpack_require__.bind(__webpack_require__, 493973));
});
var GlobalAuthModal = function() {
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useDispatch */ .I0)();
    var ref = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(function(state) {
        var ref, ref1;
        return {
            user: state.userReducer,
            showGlobalAuthModal: (ref = state.commonReducer) === null || ref === void 0 ? void 0 : (ref1 = ref.globalAuthModal) === null || ref1 === void 0 ? void 0 : ref1.show
        };
    }), user = ref.user, showGlobalAuthModal = ref.showGlobalAuthModal;
    var toggleAuthModal = function() {
        if (!(user === null || user === void 0 ? void 0 : user.isLogin)) {
            dispatch((0,_redux_actions__WEBPACK_IMPORTED_MODULE_3__/* .toggleGlobalAuthModal */ .Qi)(false));
            return;
        }
        if (!showGlobalAuthModal) {
            return;
        }
        dispatch((0,_redux_actions__WEBPACK_IMPORTED_MODULE_3__/* .toggleGlobalAuthModal */ .Qi)(false));
    };
    if (!showGlobalAuthModal) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(AuthModal, {
        toggleModal: toggleAuthModal,
        isVisible: showGlobalAuthModal
    });
};
/* harmony default export */ __webpack_exports__["default"] = (GlobalAuthModal);


/***/ })

}]);